module.exports = __webpack_public_path__ + "static/media/BoundWorx_Resin_Bound_Guarantee.2ffa9a03.pdf";